export default "__VITE_ASSET__9b03c24a__"